import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useMicUnits = () => {

    const [unitsMic, setUnitsMic] = useState([]);
    const [unitsId, setUnitsId] = useState(0);
    const [dataUnitsSearch, setUnitsSearch] = useState([]);


    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();
    
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false)
    const [formValues, handleInputChange, reset, handleUpdateValues,] = useForm({
        unit: "",
        abbreviation: "",
    });
    const [validaciones, setValidaciones] = useState({
        name_valid: false,
    })
    const { unit, abbreviation } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(unitsMic.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listUnits = [];
        unitsMic.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listUnits.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setUnitsMic(listUnits);
    }, [totalPageCount, currentPage])

    // const toggle = () => {
    //     setModal(!modal);
    // }

    
    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };
    

    useEffect(() => {
        getUnits();
    }, [history.location]);


    const getUnits = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "UnitsMicro/List");

        if (respuesta.code === 200) {
            let listUnits = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((data, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    listUnits.push({
                        id_mic_cat_units: data.id_mic_cat_units,
                        unit: data.unit,
                        abbreviation: data.abbreviation,
                        visibleTable: visibleTable
                    });
                });
                setUnitsMic(listUnits);
                setUnitsSearch(listUnits);
            }
        }
    }


    const handleCreate = () => {
        handleUpdateValues({
            unit: "",
            abbreviation: "",
        });

        setUnitsId(0);
        setMethod("create");
        setModalTitle("Crear nueva unidad de medida");
        openDialog("Crear unidad de medida", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "UnitsMicro");
        if (respuesta.code === 200) {
            getUnits();
            createSweet("create", "success", "Éxito!", "Unidad de medida creada con éxito");
            setLoading(false);
            closeDialog();
        }
    }

    const handleUpdate = (id_mic_cat_units) => {
        let units = unitsMic.find(s => s.id_mic_cat_units === id_mic_cat_units);

        handleUpdateValues({
            unit: units.unit,
            abbreviation: units.abbreviation,
        });

        setValidaciones({
            name_valid: false,
        });

        setUnitsId(id_mic_cat_units);
        setMethod("update");
        setModalTitle("Modificación de la unidad");
        openDialog("Modificar unidad de medida", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);


        let body = {
            id_mic_cat_units: unitsId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "UnitsMicro/Update");

        if (respuesta.code === 200) {
            getUnits();
            createSweet("create", "success", "Exito!", "Unidad de medida actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (id_mic_cat_units) => {

        let units = unitsMic.find(s => s.id_mic_cat_units === id_mic_cat_units);

        handleUpdateValues({
            unit: units.unit,
            abbreviation: units.abbreviation,
        });

        setUnitsId(id_mic_cat_units);
        setMethod("delete");
        setModalTitle("Eliminar unidad de medida");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `UnitsMicro/${unitsId}`);

        if (respuesta.code === 200) {
            getUnits();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Unidad de medida eliminada");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }


    }

    const handleExcelMicUnits = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = unitsMic.map((item, index) => ({
                "#": index + 1,
                "Abreviación": item.abbreviation || "---",                             
                "Unidad": item.unit || "---",   
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado_mic_unidades");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_mic_unidades.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };

    const [searchMicUnit, setSearchMicUnit] = useState("");

    const handleSearch = (e) => {
        setSearchMicUnit(e);

        let busqueda = e.toUpperCase();
        let newMicUnit = [];

        if (busqueda === "") {
            setUnitsMic([...dataUnitsSearch]); 
        } else {
            dataUnitsSearch.forEach(element => {
                let nombre = element.unit.toUpperCase();
                let abrev = element.abbreviation ? element.abbreviation.toUpperCase() : "";

                if (nombre.indexOf(busqueda) > -1 || abrev.indexOf(busqueda) > -1) {
                    newMicUnit.push(element);
                }
            });
            setUnitsMic(newMicUnit);
        }
    };

    const handleClear = () => {
        setSearchMicUnit("");                         
        localStorage.removeItem("globalFilter");    
        setUnitsMic([...dataUnitsSearch]);
    };




    return {
        unitsMic, unit, abbreviation, validaciones,
        method,
        handleInputChange, loading,
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,

        showDeleteAlert, closeDeleteAlert, modalAlert,
        handleExcelMicUnits, loadingExport, handleSearch, searchMicUnit,
        handleClear,
    }

}




